import React from 'react';
import ServiceDetailPage from './Common/ServiceDetailPage';

const ServiceUiUxDevelopment = () => {
  return (
    <ServiceDetailPage
      title="UI/UX Development"
      heading="Thoughtful interfaces that help users feel at ease"
      intro="App Core Innovation creates user interfaces and experiences that are clear, modern, and built around how real people interact with products. We combine structure, visual clarity, and practical usability to help products feel effortless."
      imageSrc="/assets/images/banner/gradient-texture-technology-twitter-header_23-2149156062.avif"
      imageAlt="UI UX development illustration"
      features={[
        'User flow planning and wireframing',
        'Modern interface design and design system thinking',
        'Responsive layouts for web and mobile',
        'Design implementation that supports growth and iteration'
      ]}
      deliverables={[
        'Wireframes and interactive screen maps',
        'Visual design and component system',
        'Responsive implementation and refinement',
        'Design handoff and future improvement guidance'
      ]}
      outcomes={[
        'A product experience that feels easier to understand and use',
        'Stronger trust and better conversions',
        'A cleaner foundation for future product updates'
      ]}
      stats={[
        { label: 'Design focus', value: 'User-first' },
        { label: 'Best fit', value: 'Products' },
        { label: 'Approach', value: 'Practical & modern' }
      ]}
      sideTitle="Why this service matters"
      sideText="Good design is not just visual polish. It reduces friction, supports confidence, and makes every interaction feel more intentional."
    />
  );
};

export default ServiceUiUxDevelopment;
